<template>
  <div class="control-textbox">
    <div class="control-textbox__content text">
      <input v-model="query"
             id="app-search-input"
             class="control-textbox__input"
             :class="className"
             type="text"
             :placeholder="control.placeholder"
             @keyup.enter="updateFilters"/>
      <label class="sr-only" for="app-search-input">Search</label>

      <button v-if="query" class="control-textbox__clear fas fa-times-circle search-clear" type="button" title="Clear" @click="clearSearchTerm()"/>

      <button v-if="control.searchButton" class="control-textbox__submit" type="button" :disabled="query === undefined || query.length === 0" @click="updateFilters">
        <i class="fas fa-search"></i>
        <span class="sr-only">search</span>
      </button>
    </div>
  </div>
</template>

<script>
import he from 'he';
import { mapState, mapActions, mapMutations } from 'vuex';
import windowWidthMixin from '../../mixins/window-width';

export default {
  props: ['control', 'className', 'parent'],
  mixins: [windowWidthMixin],
  data: function () {
    return {
      query: he.decode(this.parent.defaultValue),
    };
  },
  computed: {
    ...mapState({
      spec: state => state.listing.specification,
    }),
  },
  watch: {
    query: {
      handler(value) {
          if(typeof(value) !== 'undefined')
        this.$emit('updateQueryValue', value);
      }
    },
    spec: {
      handler(value) {
        if (value[this.control.specification] !== '' && value[this.control.specification] !== null) {
          this.query = value[this.control.specification];
        }
      },
      immediate: true,
      deep: true,
    }
  },
  mounted: function () {
    // clear current input on reset
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'listing/resetSpecification') {
        this.query = this.control.defaultValue;
      }
    });
  },
  methods: {
    ...mapMutations('listing', { updateSpecification: 'updateSpecification' }),
    clearSearchTerm() {
      if (this.query !== '') {
        this.query = '';
        this.updateFilters();
      }
    },
    updateFilters() {
      this.updateSpecification({
        key: this.control.specification,
        value: he.decode(this.query),
        manualSearch: this.isSmallScreen
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.control-textbox {
  &__content {
    height: 62px;
    background: #FFFFFF;
    border-radius: 1rem;
    border: 2px solid #DDE0DC;
    display: flex;
    padding: 0 1rem;
    position: relative;
  }
  &__clear {
    padding: 0;
    border-radius: 1rem;
    background: transparent;
    color: #333333;
    position: absolute;
    right: 2.5rem;
    top: 1.125rem;
  }
  &__submit {
    padding: 0;
    background: transparent;
    border-radius: 1rem;
    color: #333333;
  }
  &__input {
    flex: 1;
    margin: auto 0;
    background: transparent !important;
    padding-left: 0 !important;
    padding-right: 2rem !important;
    border: 0 !important;
    font-weight: 700 !important;
    font-size: 1.125rem !important;
    min-width: 0 !important;
    &::placeholder {
      color: #333333 !important;
      opacity: 1 !important;
    }
  }
}
</style>